<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import FooterWrapper from "@/components/FooterWrapper";

export default {
  // Included components
  components: {
    FooterWrapper,
  },

  data() {
    return {
      // The email address that is being reset
      email: "",

      // The confirmation token provided in the email
      token: "",

      // The user-entered password to reset to
      password: "",

      // Confirmation of the new password
      confirmPassword: "",
    };
  },

  computed: {
    // Mapped vuex state
    ...mapState(["teams"]),
    ...mapGetters(["authenticated"]),
  },

  watch: {
    // When the password changes, validate whether the confirmation matches
    password() {
      this.validate();
    },

    // When the password confirmation changes, validate whether the
    // password matches
    confirmPassword() {
      this.validate();
    },
  },

  // When the component is created, set the email and token based on query params
  created() {
    this.email = this.$route.query.email || "";
    this.token = this.$route.query.token || "";
  },

  methods: {
    // Validate that the two password fields match
    validate() {
      if (
        this.password &&
        this.confirmPassword &&
        this.password != this.confirmPassword
      ) {
        this.$refs.confirmPasswordInput.setCustomValidity(
          "Passwords do not match"
        );
      } else {
        this.$refs.confirmPasswordInput.setCustomValidity("");
      }
    },

    // When the form is submitted, reset the password via the API
    async submit() {
      let success = await this.setPassword({
        email: this.email,
        password: this.password,
        token: this.token,
      });

      if (success) {
        await this.$router.push("/log-in");
      }
    },

    // Mapped vuex actions
    ...mapActions(["setPassword"]),
    ...mapMutations(["setActiveTeamId"]),
  },
};
</script>

<template>
  <FooterWrapper>
    <b-container class="mt-3">
      <b-row align-h="center">
        <b-col lg="9" xl="8">
          <h1>Reset Password</h1>
          <b-card>
            <b-card-text>
              <b-form @submit.stop.prevent="submit">
                <b-form-group id="email-group" label="Email" label-for="email">
                  <b-form-input
                    required
                    id="email"
                    type="email"
                    v-model="email"
                    placeholder="Email"
                  ></b-form-input>
                </b-form-group>

                <b-row>
                  <b-col>
                    <b-form-group
                      id="password-group"
                      label="Password"
                      label-for="password"
                    >
                      <b-form-input
                        required
                        id="password"
                        type="password"
                        v-model="password"
                        placeholder="Password"
                        minlength="8"
                      ></b-form-input>
                      <small class="form-text text-muted">
                        Password must be at least 8 characters.
                      </small>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="confirm-password-group"
                      label="Confirm Password"
                      label-for="confirm-password"
                    >
                      <input
                        required
                        ref="confirmPasswordInput"
                        id="confirm-password"
                        type="password"
                        v-model="confirmPassword"
                        placeholder="Confirm Password"
                        class="form-control"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-button type="submit" variant="primary">
                  Set Password
                </b-button>
              </b-form>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </FooterWrapper>
</template>
